/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zotero_Checking_FilesInputs */

const en_zotero_checking_files = /** @type {(inputs: Zotero_Checking_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checking files…`)
};

const es_zotero_checking_files = /** @type {(inputs: Zotero_Checking_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprobando archivos…`)
};

/**
* | output |
* | --- |
* | "Checking files…" |
*
* @param {Zotero_Checking_FilesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const zotero_checking_files = /** @type {((inputs?: Zotero_Checking_FilesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zotero_Checking_FilesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_zotero_checking_files(inputs)
	return en_zotero_checking_files(inputs)
});